import React from 'react';
import { useObservable } from 'react-use-observable';

import { FilterOutlined as FilterOutlineIcon } from '@ant-design/icons';
import { Row, Col, Button } from 'antd';

import isAfter from 'date-fns/isAfter';
import startOfDay from 'date-fns/startOfDay';
import { Form as FormikForm, Field, useFormikContext } from 'formik';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectAffiliate } from 'v2/components/Shared/FormFields/SelectAffiliate';
import type { IAffiliateCommissionFilter } from 'v2/interfaces/reports/affiliateCommissions';
import { affiliateCommissionsService, initialFilter } from 'v2/services/reports/affiliateCommissions';

export const Form = () => {
  const { isValid, isSubmitting, resetForm, dirty } = useFormikContext<IAffiliateCommissionFilter>();

  const [isLoading] = useObservable(() => affiliateCommissionsService.isLoading(), []);

  const isOutsideRange = (day: Date) => isAfter(startOfDay(day), startOfDay(new Date()));

  const handleClean = () => {
    resetForm({ values: initialFilter });
  };

  const isCleanDisabled = !dirty || isSubmitting || isLoading;
  const isFilterDisabled = !isValid || isSubmitting || isLoading;

  return (
    <FormikForm>
      <div id='commissions-paid-to-affiliates' className='mb-4 flex w-full max-md:flex-wrap'>
        <Row gutter={[16, 16]} className='flex-1' align='bottom'>
          <Col xs={24} sm={12} md={6}>
            <Field
              label='Período'
              id='date'
              name='date'
              component={DateRangePickerFormField}
              isPresetLonger
              isOutsideRange={isOutsideRange}
            />
          </Col>
          <Col xs={24} sm={12} md={10}>
            <Field
              id='affiliates'
              name='affiliates'
              label='Afiliados'
              placeholder='Selecione o(s) afiliado(s)'
              component={SelectAffiliate}
              fullWidth
            />
          </Col>
          <Col xs={24} md={8}>
            <div className='flex gap-2'>
              <Button id='clean-filter-button' onClick={handleClean} type='text' block disabled={isCleanDisabled}>
                Limpar
              </Button>
              <Button
                id='filter-button'
                type='primary'
                disabled={isFilterDisabled}
                htmlType='submit'
                block
                loading={isSubmitting || isLoading}
                icon={<FilterOutlineIcon className='mr-0 text-sm' />}
              >
                Filtrar
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </FormikForm>
  );
};
